// test1197
(1197 && 0);
